import notifications from '@/api/notifications'
import updateRecord from '@/utils/update-record'
import { AppHolder } from '@/utils/app-holder'
import humps from 'humps'
import findIndex from 'lodash/findIndex'

export default () => ({
  namespaced: true,

  state: {
    newList: [],
    list: [],
    total: 0,
    nbPages: 1,
    lastPage: 1,
    nbUnread: 0
  },

  actions: {
    fetch (context, { page, cached } = { page: 1, cached: true }) {
      if (!page) {
        page = 1
      }
      if (cached && page === context.state.lastPage && context.state.list.length) {
        return Promise.resolve()
      }

      return notifications.fetch(page)
        .then(data => {
          context.commit('setLastPage', page)
          context.commit('fetch', data)
        })
    },

    add (context, data) {
      data.event = humps.camelize(data.event)
      data.createdAt = Date.now()
      switch (data.event) {
        case 'accountFetched':
          AppHolder.store.dispatch('accounts/fetch', false)
          AppHolder.store.dispatch('user/fetch', false)
          break
        case 'accountDeleted':
          AppHolder.store.dispatch('accounts/fetch', false)
          AppHolder.store.dispatch('user/fetch', false)
          break
      }
      context.commit('add', data)
    },

    read (context, ids) {
      if (!Array.isArray(ids)) {
        ids = [ids]
      }
      return Promise.all(ids.map(id => notifications.read(id)))
        .then(() => ids.forEach(id => context.commit('setRead', id)))
    },

    readAll (context) {
      return notifications.readAll()
        .then(() => context.state.list.forEach(notification => context.commit('setRead', notification.id)))
        .then(() => context.commit('setNbUnread', 0))
    }
  },

  mutations: {
    fetch (state, { data, meta }) {
      const { list } = state
      data && data.forEach(notification => updateRecord(list, {
        ...notification,
        event: humps.camelize(notification.event),
        createdAt: notification.createdAt * 1000
      }))
      state.list = [...state.list]
      state.nbPages = meta.totalPages
      state.nbUnread = meta.unreadNb
    },

    add (state, data) {
      if (data.kind !== 'system' && data.payload && data.payload.notificationId) {
        const index = findIndex(state.list, { id: data.payload.notificationId })
        if (index === -1) {
          state.list = [
            ...state.list,
            {
              ...data,
              id: data.payload.notificationId
            }
          ]
        } else {
          state.list = [
            ...state.list.slice(0, index),
            {
              ...data,
              id: data.payload.notificationId
            },
            ...state.list.slice(index + 1)
          ]
        }
      }
      state.newList = [
        ...state.newList,
        data
      ]
    },

    setLastPage (state, page) {
      state.lastPage = page
    },
    setRead (state, id) {
      const listIndex = findIndex(state.list, { id })
      const newListIndex = findIndex(state.newList, { payload: { notificationId: id } })
      if (listIndex >= 0 && !state.list[listIndex].read) {
        state.list = [
          ...state.list.slice(0, listIndex),
          { ...state.list[listIndex], read: true },
          ...state.list.slice(listIndex + 1)
        ]
        if (state.nbUnread > 0) {
          state.nbUnread--
        }
      }
      if (newListIndex >= 0) {
        state.newList = [
          ...state.newList.slice(0, newListIndex),
          { ...state.newList[newListIndex], read: true },
          ...state.newList.slice(newListIndex + 1)
        ]
      }
    },
    setNbUnread (state, nbUnread) {
      state.nbUnread = nbUnread
    }
  },

  getters: {
    unread ({ newList }) {
      return newList.filter(notification => !notification.read).length
    }
  }
})
